module.exports = __webpack_public_path__ + "UX18.png?72e83db21068c1ff1c875057717179f5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/UX18.png
// module id = 67
// module chunks = 0